export const tooltipBtn = ({ html, text, position = "top" }) => {
  const isTop = position !== "bottom";
  const posClass = isTop ? "siri-tip--top" : "siri-tip--bottom";
  return `
    <span class="siri-tip ${posClass}" data-siri-tip="${String(text).replace(/"/g, "&quot;")}">
      ${html}
    </span>
  `;
};
